import { InsightExampleTrendComponent } from './insight-example-trend/insight-example-trend.component';
import { InsightExampleGaugeComponent } from './insight-example-gauge/insight-example-gauge.component';
import { InsightExampleBarComponent } from './insight-example-bar/insight-example-bar.component';
import { InsightExampleLineComponent } from './insight-example-line/insight-example-line.component';
import { InsightExampleListComponent } from './insight-example-list/insight-example-list.component';
import { InsightExamplePieComponent } from './insight-example-pie/insight-example-pie.component';
import { InsightExampleTableComponent } from './insight-example-table/insight-example-table.component';
import { InsightExampleTextComponent } from './insight-example-text/insight-example-text.component';
import { InsightWorkingHoursComponent } from './insight-working-hours/insight-working-hours.component';
import { InsightPlannedHoursComponent } from './insight-planned-hours/insight-planned-hours.component';
import { InsightBookedHoursComponent } from './insight-booked-hours/insight-booked-hours.component';
import { InsightAvailableHoursComponent } from './insight-available-hours/insight-available-hours.component';
import { InsightContractPlannedComponent } from './insight-contract-planned/insight-contract-planned.component';
import { InsightRealizationComponent } from './insight-realization/insight-realization.component';
import { InsightLeaveComponent } from './insight-leave/insight-leave.component';
import { InsightBillableHoursComponent } from './insight-billable-hours/insight-billable-hours.component';
export var INSIGHTS_COMPONENTS = [
    InsightExampleTrendComponent,
    InsightExampleGaugeComponent,
    InsightExampleBarComponent,
    InsightExampleLineComponent,
    InsightExampleListComponent,
    InsightExamplePieComponent,
    InsightExampleTableComponent,
    InsightExampleTextComponent,
    InsightWorkingHoursComponent,
    InsightPlannedHoursComponent,
    InsightBookedHoursComponent,
    InsightAvailableHoursComponent,
    InsightContractPlannedComponent,
    InsightRealizationComponent,
    InsightLeaveComponent,
    InsightBillableHoursComponent
];
var InsightsModule = /** @class */ (function () {
    /**
     *Creates an instance of InsightsModule.
     */
    function InsightsModule() {
        INSIGHTS_COMPONENTS.forEach(function (insight) {
            insight.register();
        });
    }
    return InsightsModule;
}());
export { InsightsModule };
